// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-header[data-v-013ecca8]{background-color:#bcbfcc!important;border-radius:5px;margin-bottom:15px;color:#fff}.float-right[data-v-013ecca8]{width:32%}.error-message[data-v-013ecca8],.float-right .md-title[data-v-013ecca8]{text-align:center}.error-message[data-v-013ecca8]{padding:30px 0;color:red;font-size:20px;font-weight:600}.button-div[data-v-013ecca8]{float:right}.income-trigger-count[data-v-013ecca8]{margin-right:20px;margin-top:15px}", ""]);
// Exports
module.exports = exports;
